import { render, staticRenderFns } from "./publish-youtube.vue?vue&type=template&id=1970b648&scoped=true&"
import script from "./publish-youtube.vue?vue&type=script&lang=js&"
export * from "./publish-youtube.vue?vue&type=script&lang=js&"
import style0 from "./publish-youtube.vue?vue&type=style&index=0&id=1970b648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970b648",
  null
  
)

export default component.exports